import service from '../util/yd'
import http from '../util/http'
import http2 from '../util/jc'
// let api = '/api'
let api = ''
// 
export const fanyi = (data) => {
  return service({
    url:  '',
    method: 'post',
    data
  })
}
// 翻译接口
export const translate = (data) => {
  return http({
    url:  '/manage/staff/translate',
    method: 'post',
    data
  })
}

export const getXmlId = (data) => {
  return http2({
    url:  `/engine-rest/process-instance/${data}/activity-instances`,
    method: 'get',
    data
  })
}

export const getXml = (data) => {
    return http2({
      url:  `/engine-rest/process-definition/${data}/xml`,
      method: 'get',
      data
    })
  }
  // 拿到反馈单数据  
  export const getfeedBackData = (data) => {
    return http2({
      url:  `/engine-rest/process-instance`,
      method: 'post',
      data
    })
  }